module.exports = __webpack_public_path__ + "static/img/third2_1_4.8c6e59ae.jpg";